import { render, staticRenderFns } from "./TableVirtualLoading.vue?vue&type=template&id=49fcbed8&scoped=true"
import script from "./TableVirtualLoading.vue?vue&type=script&lang=js"
export * from "./TableVirtualLoading.vue?vue&type=script&lang=js"
import style0 from "./TableVirtualLoading.vue?vue&type=style&index=0&id=49fcbed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fcbed8",
  null
  
)

export default component.exports